import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
import 'geniebook-ui/dist/index.css';
import { DEFAULT_STALE_TIME_IN_SECONDS } from '@utils/constants/global.constants';

Sentry.init({
  dsn: process.env.SENTRY_DSN_KEY,
  integrations: [new Sentry.Replay()],
  enabled: process.env.REACT_ENVIRONMENT != 'localhost',
  environment: process.env.REACT_ENVIRONMENT,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/[-a-z0-9.]*geniebook.(com|vn|dev)/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      notifyOnChangeProps: ['data'],
      refetchOnWindowFocus: false,
      staleTime: DEFAULT_STALE_TIME_IN_SECONDS * 1000, // by default all the API queries will have 2 seconds stale time
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
    <ReactQueryDevtools initialIsOpen={true} />
  </QueryClientProvider>,
);
